import { message } from "antd";
import { token } from "../../constants/Constants";
import { get_all_test_categories } from "../../endpoints/API";

export const fetchTestCategory = async (
  setTestCategory,
  baseUrl,
  prodTestUrl
) => {
  try {
    const response = await get_all_test_categories();

    if (response.statusText=="OK") {
      const data = response?.data;
      setTestCategory(data);
    } else {
      message.error("Failed to fetch test category.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching test category.");
  }
};
